import React, { useEffect } from "react";
import { ErrorBoundary } from "@vz/react-util";
import { useNavigate } from 'react-router-dom';
import { dispatchError } from "../utils/tagging";

const ErrorPage = ({ errorDetails }) => {

    const navigate = useNavigate();
    const errorCode = errorDetails?.responseInfo?.responseCode;
    const items = errorDetails?.body?.sections[0]?.contents[0].items;
    const title = items?.find(c => c.itemKey === "headerText");
    const message = items?.find(c => c.itemKey === "subHeaderText");

    useEffect(()=>{
        let errMsgDisplayed =`${errorCode}|${message?.itemValue}`;
        dispatchError(errMsgDisplayed)
    },[])

    return errorCode == '512' ? <ErrorBoundary errorcode={errorCode} title={title?.itemValue} message={message?.itemValue}
        action={{ name: 'Go home', value: () => { window.location.href = window.location.origin + '/digital/nsa/secure/ui/intl/' } }}

    ></ErrorBoundary>
    :
    <ErrorBoundary errorcode={errorCode} title={title?.itemValue} message={message?.itemValue}
        retryCallbackFn={
            () => window.location.reload()
        }
        goBackCallbackFn={
            () => navigate(-1)
        }
    >

    </ErrorBoundary>

}

export default ErrorPage;